import { useEffect, useState } from "react";

function getIsMobile() {
  return typeof window !== "undefined" && window.innerWidth < 768;
}

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return undefined;
    }

    const mq = window.matchMedia("(max-width: 767px)");
    const handler = (event) => setIsMobile(event.matches);
    setIsMobile(mq.matches);
    mq.addEventListener("change", handler);

    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
